/* eslint-disable @typescript-eslint/naming-convention */
import Api, { HttpMethod } from './index';
import { IFromFindSalonsResponse } from './IDataMappings';
import { ISalonPatchResponse } from './IApiResponses';

interface ISalonApiConfig {
  api: Api;
}

interface IUpdateSalonArgs {
  selectedSalonId: string;
  stylistName: string;
  isPrivacyPolicyAccepted: boolean;
}

export default class SalonApi {
  api: Api;

  constructor({ api }: ISalonApiConfig) {
    this.api = api;
  }

  async getSalons(location: string): Promise<IFromFindSalonsResponse> {
    const response = await this.api.makeRequest(HttpMethod.GET, {
      options: {
        credentials: 'include',
      },
      params: {
        primary_filter: 'canAffiliate',
      },
      url: `${this.api.basePath}/util/doorlookup/${location}`,
    });

    return this.api.dataMapper.mapResponse('fromFindSalons', response) as IFromFindSalonsResponse;
  }

  async updateSalon({
    selectedSalonId,
    stylistName,
    isPrivacyPolicyAccepted,
  }: IUpdateSalonArgs): Promise<ISalonPatchResponse> {
    const response = await this.api.makeRequest(HttpMethod.PATCH, {
      body: {
        salon_data_share_flag: isPrivacyPolicyAccepted,
        salon_id: selectedSalonId,
        stylist_name: stylistName,
      },
      options: {
        credentials: 'include',
      },
      url: `${this.api.baseTransactionPath}/${this.api.transId}/salon_commission`,
    });
    return response as ISalonPatchResponse;
  }
}
